import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DataGridCustom, Grid, Input } from '../../../components/index';
import * as listUtils from '../../../utils/listsSelect';
import User from '../../../domain/User';
import { msgConflitosPeriodos } from '../../../utils/constants';

class RequerimentosConflitosPeriodos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      nomeAprovador: '',
      dataAprovacao: '',
    };
  }

  componentDidMount() {
    this.verificarCheck();
  }

  verificarCheck = () => {
    if (this.props.requerimentoConflito && this.props.requerimentoConflito.veioPreenchidoDoBanco) {
      this.setState({
        checked: true,
      });
    }
  }

  toggleCheckbox = () => {
    const usuarioLogado = User.logged();
    if (this.state.checked) {
      this.setState({
        checked: false,
        nomeAprovador: '',
        dataAprovacao: '',
      });
      this.props.onUpdateConflito({
        idConflito: this.props.idConflito,
        nomeAprovador: '',
        dataAprovacao: '',
        cpfAprovador: null,
        inAprovacao: 0,
      });
    } else {
      const nome = usuarioLogado.nome();
      const data = new Date().toLocaleDateString('pt-BR');
      this.setState({
        checked: true,
        nomeAprovador: nome,
        dataAprovacao: data,
      });
      this.props.onUpdateConflito({
        idConflito: this.props.idConflito,
        nomeAprovador: nome,
        dataAprovacao: data,
        cpfAprovador: usuarioLogado.cpf(),
        inAprovacao: 1,
      });
    }
  };

  addTipoEstadoLabel = (tipo) => {
    if (tipo === 15) {
      return 'Exigência/indeferido';
    }

    if (tipo === 16) {
      return 'Indeferimento ratificado';
    }

    if (tipo === undefined || tipo === null) {
      return '';
    }

    return listUtils.getObject(listUtils.tiposEstado, tipo).label;
  };

  verificarTamanhoInput = (value) => {
    if (value === undefined || value === null) {
      return '';
    }
    const qtdMaxCharacterInput = 42;
    return value.length > qtdMaxCharacterInput ? value : '';
  }

  formatarCpf = (cpf) => {
    let retorno = '';
    if (cpf) {
      retorno = cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4');
    }
    return retorno;
  };

  render() {
    const {
      titulo, requerimentoConflito, exibirCheckbox, status,
    } = this.props;
    const { checked, nomeAprovador, dataAprovacao } = this.state;
    const usuarioLogado = User.logged();
    const STATUS = { NAO_RESOLVIDO: 0, RESOLVIDO: 1 };
    const mostrarCheckbox = (exibirCheckbox && status === STATUS.NAO_RESOLVIDO && !requerimentoConflito.veioPreenchidoDoBanco) &&
      (
        (usuarioLogado.isRPPS() && usuarioLogado.cnpjDoPapel() === requerimentoConflito.cnpjDestinatario) ||
        (usuarioLogado.isRGPS() && (!requerimentoConflito.cnpjDestinatario || requerimentoConflito.cnpjDestinatario.trim() === ''))
      );

    return (
      <React.Fragment>
        <DataGridCustom title={`${titulo} - ${requerimentoConflito.protocolo}`}>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input disabled label="CPF" value={this.formatarCpf(requerimentoConflito.cpf)} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input disabled label="Nome" value={requerimentoConflito.beneficiario} title={this.verificarTamanhoInput(requerimentoConflito.beneficiario)} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input disabled label="Matrícula" value={requerimentoConflito.matricula} />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input disabled label="Solicitante" value={`${requerimentoConflito.nomeSolicitante} - ${requerimentoConflito.codigoSolicitante}`} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input disabled label="Destinatário" value={`${requerimentoConflito.nomeDestinatario} - ${requerimentoConflito.codigoDestinatario}`} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input disabled label="Estado do requerimento" value={this.addTipoEstadoLabel(requerimentoConflito.estado)} />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input disabled label="Data início benefício" value={requerimentoConflito.dataInicioBeneficio} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input disabled label="Data de ingresso" value={requerimentoConflito.dataIngresso} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input disabled label="Data de desvinculação" value={requerimentoConflito.dataDesvinculacao} />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input disabled label="Tempo de Contribuição no Regime Origem" value={requerimentoConflito.nuTempoContribRo} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input disabled label="Data de Cessação" value={requerimentoConflito.dataCessacao} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Motivo da Cessacão"
                value={requerimentoConflito.nomeMotivoRequerimento}
                title={this.verificarTamanhoInput(requerimentoConflito.nomeMotivoRequerimento)}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="12 12 12 12">
              <input
                type="checkbox"
                checked={checked}
                onClick={this.toggleCheckbox}
                style={{ paddingLeft: '5px', position: 'relative', top: '-2px' }}
                disabled={!mostrarCheckbox}
              />
              <span style={{ paddingLeft: '5px', position: 'relative', top: '-2px' }}>
                { msgConflitosPeriodos.reconhecimentoRequerimentoDeferidoComConflito.descricao }
              </span>
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input disabled label="Aprovado por" value={mostrarCheckbox ? nomeAprovador : requerimentoConflito.nomeAprovador || ''} />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input disabled label="Data da aprovação" value={mostrarCheckbox ? dataAprovacao : requerimentoConflito.dataAprovacao || ''} />
            </Grid>
          </div>
        </DataGridCustom>
      </React.Fragment>
    );
  }
}

RequerimentosConflitosPeriodos.propTypes = {
  idConflito: PropTypes.number.isRequired,
  titulo: PropTypes.string.isRequired,
  requerimentoConflito: PropTypes.objectOf.isRequired,
  exibirCheckbox: PropTypes.bool.isRequired,
  status: PropTypes.number.isRequired,
  onUpdateConflito: PropTypes.func.isRequired,
};

export default RequerimentosConflitosPeriodos;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/RequerimentosConflitosPeriodos.jsx